<template>
  <div style="width: 1200px; margin: 0 auto; background-color: #f2f6fc">
    <Title :title="{ name: '合同管理', path: '/system/contract/all' }"></Title>

    <div style="margin: 10px auto">
      <el-card class="box-card">
        <el-row :gutter="20" style="margin-left: 10px">
          <el-col :span="6">
            <el-input v-model="qparam.partyName" placeholder="甲方名字"></el-input>
          </el-col>
          <el-col :span="6">
            <el-input v-model="qparam.contractName" placeholder="合同名字"></el-input>
          </el-col>
          <el-col :span="8">
            <el-select v-model="qparam.paybackProcess" placeholder="回款类型">
              <el-option
                v-for="item in paybackType"
                :key="item.key"
                :label="item.key"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-left: 10px; margin-top: 10px">
          <el-col :span="9">
            <el-date-picker
                v-model="contractUpTime"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-col>
          <el-col :span="5" style="float: right">
            <el-button icon="el-icon-refresh-left" type="primary" @click="resetQparam">重置</el-button>
            <el-button icon="el-icon-search" type="primary" @click="search">查询</el-button>
          </el-col>
        </el-row>
      </el-card>
    </div>

    <div style="margin: 10px auto">
      <el-card class="box-card" style="min-height: 650px">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="contractName" label="合同名字">
          </el-table-column>
          <el-table-column prop="projectName" label="项目名字">
          </el-table-column>
          <el-table-column width="160" prop="contractUpTime" label="上传时间">
          </el-table-column>
          <el-table-column width="80" prop="contractType" label="合同类型">
            <template v-slot="scope">{{contractTypes[scope.row.contractType-1]}}</template>
          </el-table-column>
          <el-table-column width="80" prop="contractAmount" label="合同金额">
          </el-table-column>
          <el-table-column width="80" prop="contractSign" label="合同签署">
            <template v-slot="scope">{{contractSigns[scope.row.contractSign-1]}}</template>
          </el-table-column>
          <el-table-column width="80" prop="process" label="回款进度">
            <template v-slot="scope">
              <div v-if="scope.row.process >= 80" class="height">{{scope.row.process}}%</div>
              <div v-if="scope.row.process <= 40" class="low">{{scope.row.process}}%</div>
              <div v-if="scope.row.process < 80 && scope.row.process > 40" class="middle">{{scope.row.process}}%</div>
            </template>
          </el-table-column>
          
          <el-table-column width="200" label="操作">
            <template v-slot="scope">
              <el-button size="mini" @click="viewPdf(scope.row['contractId'])">查看</el-button>
              <el-button
                size="mini"
                type="primary"
                @click="showPayback(scope.row)"
                >回款
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 40px auto; width: 30%">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="currentPageChangeEvent"
            :current-page="qparam.current"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="qparam.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements"
          >
          </el-pagination>
        </div>
      </el-card>
      
      <el-dialog :visible.sync="isPayback" title="合同回款" top="6vh">
        <el-form label-position="left" label-width="100px" :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item label="合同名字">{{currentName}}</el-form-item>
          <el-form-item label="合同金额">￥{{currentAmount}}</el-form-item>
          <el-form-item label="回款金额">￥{{totalAmount}}</el-form-item>
          <el-form-item label="回款历史" v-show="paybacks.length > 0">
            <el-timeline>
              <el-timeline-item
                v-for="(item, index) in paybacks"
                :key="index"
                :timestamp="item.paybackTime">
                <div class="paybackInfo">
                  <div>￥{{item.contractAmount}}</div>
                  <div v-if="paybackStatus === 1 && hasRole" class="paybackInfo-btn" @click="updatePayback(item.id, item.contractAmount)">修改</div>
                  <div v-if="paybackStatus === 1 && hasRole" class="paybackInfo-btn" @click="removePayback(item.id)">删除</div>
                </div>
              </el-timeline-item>
            </el-timeline>
          </el-form-item>
          <div v-if="hasRole">
            <div v-if="paybackStatus === 1">
              <el-form-item label="回款金额" prop="amount" maxlength="12">
                <el-input v-model="ruleForm.amount"></el-input>
              </el-form-item>
              <el-form-item label="回款进度">
                <el-select v-model="ruleForm.paybackType" placeholder="回款类型">
                  <el-option
                    v-for="item in paybackType"
                    :key="item.key"
                    :label="item.key"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-button type="primary" @click="submitPayback">提交</el-button>
            </div>
            <div v-else>
              <el-form-item label="回款进度">
                <el-tag type="success">回款完成</el-tag>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </el-dialog>
      <el-dialog title="合同信息" v-if="showInfo" :visible.sync="showInfo" top="6vh" width="1200px">
        <ContractDialog :contract-id="contractId"></ContractDialog>
      </el-dialog>
      
    </div>
  </div>
</template>

<script>
import Title from "@/components/Title";
import {requestAllContract, requestPayback, requestDelPayback, requestGetPaybackRecords, requestUpdatePaybackProcess} from "@/api"
import {minioServer, IsPdf, isNum, AesDecrypt} from "@/util";
import ContractDialog from "@/components/item/common/ContractDialog.vue";

export default {
  name: "AllContract",
  components: {Title, ContractDialog},
  data() {
    const validatePrice = (rule, value, callback) => {
      if (!value) {
        callback(new Error("金额不能为空"));
      } else if (!isNum(value)) {
        callback(new Error("请输入正确格式的金额"));
      } else if (value.split(".").length > 2) {
        callback(new Error("请输入正确格式的金额")); //防止输入多个小数点
      } else if (value.indexOf(".") > -1 && value.substring(value.indexOf(".") + 1).length > 2) {
        callback(new Error("最大保留两位小数"));
      } else if (value.length > 12) {
        callback(new Error("长度最大12个字符"))
      } else {
        this.ruleForm.projectAmountExpect = value
        callback();
      }
    };
    return {
      user: {},
      hasRole: false,
      contractTypes: ["销售合同","渠道合同","框架协议","采购合同"],
      contractSigns: ["御码网控","中科安永"],
      showInfo: false,
      contractId: "",
      contractUpTime: [],
      tableData: [],
      totalElements: 0,
      pdfurl: "",
      isPayback: false,
      
      currentId: "",
      currentName: "",
      currentAmount: "",
      totalAmount: 0,
      
      process: "",
      paybackType: [
        {
          value: 1,
          key: "回款中"
        },
        {
          value: 2,
          key: "回款完成"
        }
      ],
      paybacks: [],
      paybackStatus: "",
      qparam: {
        current: 1,
        size: 10,
        partyName: "",
        contractName: "",
        startTime: "",
        endTime: "",
        paybackProcess: ""
      },
      ruleForm: {
        amount: "",
        paybackType: 1
      },
      rules: {
        amount: [{required: true, validator: validatePrice, trigger: 'blur'}],
      },
    }
  },
  created() {
    let data = AesDecrypt(window.localStorage.getItem("user"));
    const user = JSON.parse(data);
    this.initTableData()
    this.hasRole = user.roles.includes(1) || user.roles.includes(2)
  },
  methods: {
    async initTableData() {
      this.qparam.startTime = this.contractUpTime[0]
      this.qparam.endTime = this.contractUpTime[1]
      const res = await requestAllContract(this.qparam);
      if (res.code === 200) {
        this.totalElements = res.total
        this.tableData = res.rows
        let data = this.tableData
        for (let i = 0; i < data.length; i++) {
          const item = data[i]
          const payback = item.payback
          let sum = 0
          for (let p of payback) {
            sum += p.contractAmount
          }
          if (item.contractAmount === 0) {
            data[i].process = 100
          } else {
            let process = Math.ceil((sum/item.contractAmount) * 100)
            data[i].process = process > 100 ? 100 : process
          }
        }
        this.tableData = data
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSizeChange(size) {
      this.qparam.current = 1;
      this.qparam.size = size;
      this.initTableData()
    },
    resetQparam() {
      this.contractUpTime = []
      this.qparam.partyName = ""
      this.qparam.contractName = ""
      this.qparam.paybackProcess = ""
      this.initTableData()
    },
    currentPageChangeEvent(currentPage) {
      this.qparam.current = currentPage;
      this.initTableData()
    },
    async search() {
      this.qparam.current = 1
      await this.initTableData()
    },
    async payback() {},
    viewPdf(contractId) {
      this.contractId = contractId
      this.showInfo = true
    },
    async showPayback(info) {
      // 未回款 是 null 是正常的
      if (info.contractAmount === 0) {
        this.$message.info("合同金额为零，无需回款")
        return
      }
      this.ruleForm.amount = ''
      this.isPayback = true
      document.body.scrollTop = 0
      // 未回款和回款中 都应该是 1 可以回款的状态
      // 回款完成 不等于1
      this.paybackStatus = info.paybackProcess !== null ? info.paybackProcess : 1;
      await this.getPaybackRecords(info.contractId)
      this.currentId = info.contractId
      this.currentAmount = info.contractAmount
      this.currentName = info.contractName
    },
    async getPaybackRecords(id) {
      const res = await requestGetPaybackRecords({contractId: id})
      if (res.code === 200) {
        this.paybacks = res.object
        this.totalAmount = 0
        for (let item of this.paybacks) {
          this.totalAmount += item.contractAmount
        }
      } else {
        this.$message.error(res.msg)
      }
    },
    submitPayback() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          let sum = this.totalAmount + parseInt(this.ruleForm.amount)
          if (sum > this.currentAmount) {
            this.$confirm('该笔回款会使得总回款大于合同金额, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              requestPayback({
                amount: this.ruleForm.amount,
                contractId: this.currentId
              }).then(res => {
                if (res.code === 200) {
                  this.ruleForm.amount = ""
                  this.$message.success(res.msg)
                  this.getPaybackRecords(this.currentId)
                  this.updatePaybackType(this.currentId, this.ruleForm.paybackType)
                  this.initTableData()
                } else {
                  this.$message.error(res.msg)
                }
              }).catch(()=>{})
            })
          } else {
            requestPayback({
              amount: this.ruleForm.amount,
              contractId: this.currentId
            }).then(res => {
              if (res.code === 200) {
                this.ruleForm.amount = ""
                this.$message.success(res.msg)
                this.getPaybackRecords(this.currentId)
                this.updatePaybackType(this.currentId, this.ruleForm.paybackType)
                this.initTableData()
              } else {
                this.$message.error(res.msg)
              }
            })
          }
          
        }
      })
    },
    
    async updatePaybackType(contractId, type) {
      await requestUpdatePaybackProcess({
        contractId: contractId,
        paybackProcess: type
      })
    },
    
    async updatePayback(id, contractAmount) {
      if (this.paybackStatus === 2) {
        this.$message.info("回款已完成，不能进行修改")
        return
      }
      
      this.$prompt('请输入修改的金额', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: contractAmount
      }).then( async (value) => {
        const res = await requestPayback({
          paybackId: id,
          amount: value.value,
          contractId: this.currentId
        })
        if (res.code === 200) {
          this.$message.success(res.msg)
          await this.getPaybackRecords(this.currentId)
          await this.initTableData()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    async removePayback(id) {
      this.$confirm('此操作将永久删除回款记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await requestDelPayback({id: id})
        if (res.code === 200) {
          await this.getPaybackRecords(this.currentId)
          await this.initTableData()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {
      });
    },
  }
}
</script>

<style>
.paybackInfo {
  display: flex;
}
.paybackInfo-btn {
  margin-left: 12px;
  cursor: pointer;
  color: #409EFF;
}

.low {
/*  color: #f56c6c;*/
  color: red;
}
.middle {
  color: #e6a23c;
}
.height {
/*  color: #5cb87a;*/
  color: green;
}

</style>